<template>
  <header class="basic-header">
    <BasicHeaderMenu class="basic-header__icon" />
    <ModelSelect />
    <div class="basic-header__right-icon-group">
      <i class="basic-header__icon el-icon-s-flag" @click="onClickFlagIcon"></i>
      <i class="basic-header__icon el-icon-plus" @click="onClickPlusIcon"></i>
    </div>
  </header>
</template>

<script>
import BasicHeaderMenu from "./basic-header-menu/index.vue";
import ModelSelect from "@/components/model-select/index.vue";
import { mapState, mapActions } from "vuex";

export default {
  name: "BasicHeader",
  components: { BasicHeaderMenu, ModelSelect },
  computed: {
    ...mapState("user", ["signedIn"]),
  },
  methods: {
    ...mapActions(["openSignInDialog"]),

    onClickFlagIcon() {
      const { signedIn } = this;
      if (!signedIn) {
        this.openSignInDialog();
        return;
      }
      const { name: currentRouteName } = this.$route;
      const name = "Prompt";
      if (currentRouteName === name) {
        return;
      }
      this.$router.push({ name });
    },
    onClickPlusIcon() {
      const { signedIn } = this;
      if (!signedIn) {
        this.openSignInDialog();
        return;
      }
      const { name: currentRouteName } = this.$route;
      const name = "Home";
      if (currentRouteName === name) {
        document.querySelector(".question__textarea").focus();
        return;
      }
      this.$router.push({ name });
    },
  },
};
</script>

<style lang="scss" scoped>
.basic-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: var(--header-height);
  border-bottom: 1px solid #eee;

  .basic-header__icon {
    padding: 10px;
    font-size: 28px;
  }

  .basic-header__right-icon-group {
    display: flex;
    align-items: center;
  }
}

@media screen and (min-width: 768px) {
  .basic-header {
    display: none;
  }
}
</style>